
import { defineComponent, ref, watch } from 'vue';
import * as echarts from 'echarts';
import _ from 'lodash';
import { getChartData, getPointDetail, updatePointConfig } from '@/api';
import moment from 'moment';

// const COLORS = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];
export default defineComponent({
    name: 'chart',
    props: {
        point: {
            type: Object,
            default() { }
        }
    },
    setup(props) {
        const chartRef = ref(props.point.id);
        return {
            chartRef,
        }
    },
    data() {
        const option = {
            backgroundColor: 'rgba(0,0,0,0.05)',
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            grid: { left: '6%', right: '6%', containLabel: true },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                },
                {
                    start: 0,
                    end: 100
                },
            ],
            legend: {
                data: [] as any[]
            },
            xAxis: {
                type: 'category',
                data: []
            },
            yAxis: {
                max: function (value: { max: number; min: number; }) {
                    return Math.abs(value.max) > 10 ? Math.ceil(value.max + (value.max - value.min) * 0.1) : (value.max + (value.max - value.min) * 0.1).toFixed(3);
                },
                min: function (value: { min: number; max: number; }) {
                    return Math.abs(value.min) > 10 ? Math.floor(value.min - (value.max - value.min) * 0.1) : (value.min - (value.max - value.min) * 0.1).toFixed(3);
                },
                type: 'value',
            },
            series: [] as any[],
            // series: [{
            //     type: 'line',
            //     lineStyle: {
            //         color: COLORS[this.point.id % COLORS.length],
            //     },
            //     // markLine: {
            //     //     symbol: 'none',
            //     //     data: [
            //     //         {
            //     //             yAxis: 0, // 水平线的 Y 轴位置
            //     //             lineStyle: {
            //     //                 color: '#d1edc4',
            //     //                 type: 'solid',
            //     //                 width: 1
            //     //             },
            //     //             label: {
            //     //                 show: true,
            //     //                 position: 'insideEndTop',
            //     //                 formatter: '预警下限边界线'
            //     //             }
            //     //         }
            //     //     ]
            //     // },
            //     data: [],
            //     animation: {
            //         duration: 1000, // 动画时长
            //         easing: 'cubicOut', // 缓动函数
            //     }
            // }] as any[],
        }
        return {
            option: option,
            chart: null as echarts.ECharts | null,
            // history: [] as number[],
            startTime: 1,// 默认最近1个月
            detail: {
                unit: '',
                report: {
                    "interval": { "value": 1, "label": "间隔参数D" },
                    "time": { "value": "01:00:00", "label": "时间参数T" }
                }
            } as any,
            initFlag: false, // detail 数据初始化成功后， detail数据 监听生效
            loading: false, // 监听同步数据
        }
    },
    watch: {
        startTime() {
            this.fetchData();
        },
    },
    created() {

    },
    mounted() {
        this.chart = echarts.init(this.chartRef, { resize: true });
        this.chart.setOption(this.option);
        // 在 watch 钩子使用无效
        this.getDetail().then(() => {
            watch(
                () => this.detail,
                _.debounce(() => {
                    // 执行提交数据的逻辑
                    if (this.initFlag) {
                        this.update();
                    }
                }, 300), { deep: true }
            );
            this.fetchData();
        })

        window.addEventListener('resize', this.resizeChart);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.resizeChart);
        this.chart?.dispose();
    },
    methods: {
        moment,
        update() {
            this.loading = true;
            updatePointConfig({ id: this.detail.id, warning: this.detail.warning, unit: this.detail.unit, label: this.detail.label }).then(() => {
                const timer = setTimeout(() => {
                    this.loading = false;
                    clearTimeout(timer);
                }, 300);
            }).catch(() => {
                this.getDetail();
            })
        },
        async getDetail() {
            return getPointDetail(this.point.id).then(res => {
                this.detail = res.data;
                // if (!this.detail.report?.interval) {
                //     this.detail.report.interval = { "value": 1, "label": "间隔参数D" };
                // }
                // if (!this.detail.report?.time) {
                //     this.detail.report.time = { "value": "01:00", "label": "时间参数T" };
                // }

                // const { lower, upper } = this.detail.warning.level_1 || {};
                // this.option.series[0].markArea = {
                //     label: {
                //         show: true,
                //         position: 'insideLeft',
                //         color: '#529b2e',
                //         offset: [-50, 0],
                //         formatter: '安全区',
                //     },
                //     data: [
                //         [{
                //             yAxis: lower.value,  // 区间起始值
                //             itemStyle: {
                //                 color: '#95d47533',
                //             }
                //         }, {
                //             yAxis: upper.value,  // 区间结束值
                //         }]
                //     ]
                // }

            }).then(() => {
                // 数据渲染更新后开始执行监听逻辑
                this.initFlag = true;
            })
        },
        resizeChart() {
            this.chart?.resize();
        },
        fetchData() {
            getChartData(this.point?.id, { start: new Date(moment().subtract(this.startTime, 'M').format()), end: new Date() }).then((res) => {
                const data = res.data.map((item: { raw: { data: number }; collectTime: string }) => {
                    return {
                        values: item.raw.data,
                        collectTime: moment(item.collectTime).format('YYYY-MM-DD HH:mm:ss')
                    }
                })
                this.option.legend.data = [];
                this.option.series = [];
                const dataMapper = {};
                if (data.length > 0) {
                    // 取出公共的X轴时间表
                    this.option.xAxis.data = data.map((item: { collectTime: Date }) => {
                        return item['collectTime']
                    });
                    // 过滤出对应label下的所有数据，分别按照不同的折线图显示
                    for (const key in this.detail.label) {
                        const label = this.detail.label[key];
                        this.option.legend.data.push(label);
                        dataMapper[key] = []; // 用于存放 line data
                    }
                    for (let i = 0; i < data.length; i++) {
                        const item = data[i];
                        if (Array.isArray(item.values)) {
                            item.values.forEach((i: { key: string, value: string }) => {
                                if (Array.isArray(dataMapper[i.key]) && !isNaN(i.value as any)) {
                                    dataMapper[i.key].push(i.value)
                                } else {
                                    // if (dataMapper[i.key]) {
                                    //     delete dataMapper[i.key];
                                    //     if (this.option.legend.data.indexOf(this.detail.label[i.key]) > -1) {
                                    //         _.pull(this.option.legend.data, this.detail.label[i.key]);
                                    //     }
                                    // }
                                }
                            })

                        }
                    }
                    for (const key in dataMapper) {
                        const label = this.detail.label[key];
                        this.option.series.push({
                            name: label,
                            type: 'line',
                            data: dataMapper[key],
                            symbol: 'none',
                            smooth: true,
                            animation: {
                                duration: 1000, // 动画时长
                                easing: 'cubicOut', // 缓动函数
                            }
                        })
                    }
                    // this.history = this.option.series[0].data;
                }
                this.chart?.setOption(this.option);
            })
        }
    }
});
